import { render, staticRenderFns } from "./ConfirmPurchaseModal.vue?vue&type=template&id=543dafa8&scoped=true&"
import script from "./ConfirmPurchaseModal.vue?vue&type=script&lang=tsx&"
export * from "./ConfirmPurchaseModal.vue?vue&type=script&lang=tsx&"
import style0 from "./ConfirmPurchaseModal.vue?vue&type=style&index=0&id=543dafa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543dafa8",
  null
  
)

export default component.exports